import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function HeaderBar() {
  const navigate = useNavigate();
  return (
    <Card className="shadow-none mt-1 p-0">
      <Card.Body className="d-flex align-items-center py-3 px-0 flex-wrap">
        <div className="d-flex align-items-center">
          <Button
            type="button"
            onClick={() => navigate("/access-control/roles")}
            size="sm"
            aria-label="Go back"
            variant="light"
          >
            <FontAwesomeIcon
              icon="chevron-left"
              transform="shrink-2"
              className="ms-1"
            />
          </Button>
        </div>

        <div className="px-3">
          <h4 className="mb-0 fw-semibold text-base">
            Assign Roles/Privileges to User
          </h4>
        </div>
      </Card.Body>
    </Card>
  );
}
